module.exports = __webpack_public_path__ + "static/media/ic_addWhite.401107ca.svg";